import { permissionToUrl } from '@/constants';
import usePermission from '@/hooks/usePermission';
import { useAuthStore } from '@/store';
import { Box, Image } from '@chakra-ui/react';
import type React from 'react';
import { useMemo } from 'react';
import { Link } from 'react-router';

const mindsightLogoWhite = '/svgs/mindsightLogoWhite.svg';
const woundcareLogo = '/svgs/woundcare-logo.svg';

type TopbarLogoProps = {
	isCollapsed?: boolean;
	view?: 'mid' | 'desktop';
};

const TopbarLogo: React.FC<TopbarLogoProps> = ({
	isCollapsed = false,
	view = 'desktop',
}) => {
	const height = isCollapsed ? '28px' : view === 'mid' ? '40px' : '47px';
	const width = isCollapsed ? '162px' : view === 'mid' ? '140px' : '160px';

	const { hasPermission } = usePermission();
	const user = useAuthStore((state) => state.user?.userInformation);

	const firstMatchedRouteAsPerPermission = useMemo(() => Object.entries(permissionToUrl).find(([permission, _]) => {
		return hasPermission([permission]);
	}), [hasPermission, user]);

	return (
		<Link to={firstMatchedRouteAsPerPermission?.at(1) || "/profile"}>
			<Box display="flex" alignItems="center" lineHeight={0}>
				<Image
					src={user?.portsAvailable?.toLocaleLowerCase().includes('woundcare') ? woundcareLogo : mindsightLogoWhite}
					alt="Mindsight Medical"
					height={height}
					width={width}
					transition="height 0.3s ease-in-out, width 0.3s ease-in-out"
					display="block"
					objectFit="contain"
				/>
			</Box>
		</Link>
	);
};

export default TopbarLogo;
